import React from 'react';
import { CheckIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';

const SuccessIcon = () => {
  return (
    <CheckIcon
      fontSize={'xLarge'}
      color={'success'}
      sx={{
        borderRadius: '50%',
        border: '4px solid',
        borderColor: 'success',
      }}
    />
  );
};

export default SuccessIcon;
